/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { ScrollView } from "devextreme-react/scroll-view";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { Button } from "devextreme-react/button";
import Form, { Label, StringLengthRule, Item } from "devextreme-react/form";
import PayslipTableList from "./PayslipTable";
import { useAuth } from "../../../contexts/auth";
import "./style.scss";
import UsingIntl from "../../../services/using_intl";
import PopupConfig from "../../../common/popup";
import { axios } from "../../../common";

import { useScreenSize } from "../../../utils/media-query";
import notify from "devextreme/ui/notify";
import { formatMessage } from "devextreme/localization";
import TemplatePayslipSCV from "./TemplatePayslipSCV";
// import TemplatePayslip from "./TemplatePayslip";

export default function PayslipPage() {
  let dataGrid = useRef(null);
  const [payslip, setPaySlip] = useState([]);
  const formData = useRef({});
  const { user } = useAuth();
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const [popupConfigPassword, setPopupConfigPassword] = React.useState({
    popupVisible: false,
    positionOf: "",
    createdAt: Date.now(),
    data: {},
  });

  const handleOpenPopupPassword = (data) => {
    formData.current = {};
    setPopupConfigPassword({
      data: data,
      positionOf: {
        my: "center center",
        at: "center center",
      },
      popupVisible: true,
    });
  };

  const handleClosePopupPassword = () => {
    formData.current = {};
    setPopupConfigPassword({
      popupVisible: false,
    });
  };

  const { isXSmall, isSmall } = useScreenSize();
  useEffect(() => {
    UsingIntl("P0027");
  }, []);

  useEffect(() => {
    if (!user.EmployeeOid) {
      window.location.reload();
      return;
    }
    const getPayslips = async () => {
      const { data } = await axios.get(`GetPayslips`);
      setPaySlip(data);
      if (data.length === 0) {
        return;
      }

      // handleOpenPopupPassword(data[0]);
    };
    getPayslips();
  }, [user.EmployeeOid]);

  const handleGetDetailPayslip = async (payload) => {
    const newPayload = {
      EmployeeOid: user.EmployeeOid,
      PaySlipMasterOid: payload.PaySlipMasterOid,
      PasswordOpenPayslip: formData.current.PasswordOpenPayslip,
    };
    handleClosePopupPassword();
    try {
      const { data } = await axios.post("PayslipDetails", newPayload);
      if (!data) {
        notify("No Data", "error", 2000);
        return;
      }

      handleOpenPopup(data[0]);
    } catch (error) {
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  const PasswordForm = () => {
    return (
      <Form formData={formData.current}>
        <Item
          dataField="PasswordOpenPayslip"
          editorOptions={{
            mode: "password",
          }}
        >
          <StringLengthRule max="250" />
          <Label text="Password" />
        </Item>
      </Form>
    );
  };

  const renderActions = ({ data }) => {
    return (
      <>
        <Button
          type="default"
          stylingMode="outlined"
          text={formatMessage("View")}
          className="button-rounded"
          // onClick={() => handleGetDetailPayslip(data)}
          onClick={() => handleOpenPopupPassword(data)}
        />
      </>
    );
  };

  const renderViewPopupPassword = () => {
    return (
      <Popup
        visible={popupConfigPassword.popupVisible}
        onHiding={handleClosePopupPassword}
        title={formatMessage("PasswordOpenPayslip")}
        borderRadius={10}
        showTitle={true}
        width={"50%"}
        height={"auto"}
        closeOnOutsideClick={true}
      >
        <PasswordForm />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopupPassword}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Close"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={() => handleGetDetailPayslip(popupConfigPassword.data)}
          options={{
            icon: "check",
            type: "success",
            text: formatMessage("Ok"),
          }}
        />
      </Popup>
    );
  };

  const renderViewPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={popupConfig.data.SalaryTitle}
        borderRadius={10}
        showTitle={true}
        closeOnOutsideClick={true}
        width={"fit-content"}
      >
        {isSmall || isXSmall ? (
          <ScrollView height="100%">
            <TemplatePayslipSCV props={popupConfig.data} />
          </ScrollView>
        ) : (
          <ScrollView height="100%">
            <TemplatePayslipSCV props={popupConfig.data} />
          </ScrollView>
        )}
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Close"),
          }}
        />
      </Popup>
    );
  };

  return (
    <>
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("PayslipList")}
          </div>
        </div>
      </div>
      <div className={"section"}>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderViewPopup()}
          {popupConfigPassword.popupVisible && renderViewPopupPassword()}
          {/* Role list */}
          <PayslipTableList
            dataGrid={dataGrid}
            dataSource={payslip}
            renderActions={renderActions}
          />
        </div>
      </div>
    </>
  );
}
